import React, { useState } from 'react';
import { FormEvent } from 'react';
import { CheckCircle2Icon, Clock3Icon, MapPinIcon, NavigationIcon, SendIcon } from 'lucide-react';
type FormValues = {
  pickup: string;
  destination: string;
  time: string;
};
type AddressFieldProps = {
  id: 'pickup' | 'destination';
  label: string;
  placeholder: string;
  icon: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
};
function AddressField({
  id,
  label,
  placeholder,
  icon,
  value,
  onChange
}: AddressFieldProps) {
  return <div data-id="element-64" data-mp="i5pd0ax6gjpj">
      <label htmlFor={id} className="mb-1.5 block text-[12px] font-bold text-slate-700" data-id="element-65" data-mp="i6ib6ni2m0w2">
        {label}
      </label>
      <div className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-3.5 py-3 transition-colors focus-within:border-emerald-600 focus-within:ring-2 focus-within:ring-emerald-100" data-id="element-66" data-mp="88km5xse002e">
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-700" aria-hidden="true" data-id="element-67" data-mp="2sytl9y67qmca">
          {icon}
        </span>
        <input id={id} type="text" autoComplete="street-address" value={value} onChange={event => onChange(event.target.value)} placeholder={placeholder} className="min-w-0 flex-1 bg-transparent text-[14px] font-medium text-slate-900 placeholder:text-slate-400 focus:outline-none" data-id="element-68" data-mp="2m0xmz9ic25gg" />
      </div>
    </div>;
}
export function RequestForm() {
  const [values, setValues] = useState<FormValues>({
    pickup: '',
    destination: '',
    time: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const update = (field: keyof FormValues) => (value: string) => {
    setValues(current => ({
      ...current,
      [field]: value
    }));
    if (submitted) setSubmitted(false);
  };
  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitted(true);
  };
  return <section aria-labelledby="estimate-title" className="rounded-[22px] border border-slate-200 bg-[#fbfcfb] p-5" data-id="element-69" data-mp="2lclmrxus0xsz">
      <div className="flex items-start gap-3" data-id="element-70" data-mp="2pf8mekxovn0q">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[14px] bg-slate-900 text-white" data-id="element-71" data-mp="2pbuhp61jz1q4">
          <NavigationIcon className="h-5 w-5" aria-hidden="true" data-id="element-72" data-mp="2z3qi4nr433xi" />
        </span>
        <div data-id="element-73" data-mp="2z5uwy0qjtnck">
          <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-emerald-700" data-id="element-74" data-mp="343d71ugay8m5">
            Розрахунок за маршрутом
          </p>
          <h2 id="estimate-title" className="mt-0.5 text-[19px] font-bold tracking-[-0.03em] text-slate-950" data-id="element-75" data-mp="390v4ooovd1eu">
            Куди подати евакуатор?
          </h2>
        </div>
      </div>

      <form className="mt-5 space-y-3" onSubmit={onSubmit} noValidate data-id="element-76" data-mp="3i232z6rdy28x">
        <AddressField id="pickup" label="Адреса, звідки забрати" placeholder="Введіть адресу" icon={<MapPinIcon className="h-4 w-4 text-emerald-700" data-id="element-78" data-mp="1nqxsbihvspk3" />} value={values.pickup} onChange={update('pickup')} data-id="element-77" data-mp="1iqtj8djayx3w" />
        <AddressField id="destination" label="Адреса, куди відвезти" placeholder="Введіть адресу" icon={<MapPinIcon className="h-4 w-4 text-rose-600" data-id="element-80" data-mp="16galro4wc352" />} value={values.destination} onChange={update('destination')} data-id="element-79" data-mp="1be3uanto998i" />
        <div data-id="element-81" data-mp="1z46g4m6ztiyo">
          <label htmlFor="time" className="mb-1.5 block text-[12px] font-bold text-slate-700" data-id="element-82" data-mp="1z4q2cf3oetii">
            Коли забрати авто
          </label>
          <div className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-3.5 py-3 transition-colors focus-within:border-emerald-600 focus-within:ring-2 focus-within:ring-emerald-100" data-id="element-83" data-mp="1p60iwhw4t105">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-700" aria-hidden="true" data-id="element-84" data-mp="dqln3hfnsf6m">
              <Clock3Icon className="h-4 w-4" data-id="element-85" data-mp="9rmjc05nyogr" />
            </span>
            <input id="time" type="text" list="time-options" value={values.time} onChange={event => update('time')(event.target.value)} placeholder="Вкажіть зручний час" className="min-w-0 flex-1 bg-transparent text-[14px] font-medium text-slate-900 placeholder:text-slate-400 focus:outline-none" data-id="element-86" data-mp="1xkdbfpjutyq3" />
          </div>
          <datalist id="time-options" data-id="element-87" data-mp="2gacyy801r5re">
            <option value="Найближчим часом" data-id="element-88" data-mp="2lc25pbg8kx9o" />
            <option value="Через 30 хвилин" data-id="element-89" data-mp="2lar3vh6cpzl7" />
            <option value="Через 1 годину" data-id="element-90" data-mp="27capd428z4si" />
            <option value="Сьогодні ввечері" data-id="element-91" data-mp="27bhpmn1phfjv" />
          </datalist>
        </div>

        <button type="submit" className="flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-4 text-[14px] font-bold text-white transition-transform hover:bg-slate-800 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2" data-id="element-92" data-mp="2bc1l7m6msb3w">
          <SendIcon className="h-4 w-4" aria-hidden="true" data-id="element-93" data-mp="scty3bs0527a" />
          Розрахувати та надіслати заявку
        </button>
      </form>

      {submitted && <div role="status" aria-live="polite" className="mt-3 flex items-center gap-2 rounded-xl bg-emerald-50 px-3.5 py-3 text-[13px] font-semibold text-emerald-800" data-id="element-94" data-mp="12de04gnciaqk">
          <CheckCircle2Icon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-95" data-mp="9ndsia1gmjk0" />
          Заявку надіслано. Ми уточнимо маршрут і зв’яжемося з вами.
        </div>}
    </section>;
}